import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { currentUserBaseNode } from "../../redux/organization/selectors";
import { IAppState } from "../../redux/types";
import { usePathToNode } from "../../utils/hooks/hooks";
import AvaliableNodeSelect from "./AvaliableNodeSelect";

const DeviceInfo = ({ onClose }: { onClose: () => void }): JSX.Element => {
  const { t } = useTranslation("comon");
  const device = useSelector((state: any) => state.healthCheck);
  const rawMetadata = device?.subscribeData?.mobileId?.metadata;
  let parsedMetadata: any = null;
  let appVersion: string | null = null;
  let webClientVersion: string | null = null;
  console.log(rawMetadata);
  if (typeof rawMetadata === "string") {
    const trimmed = rawMetadata.startsWith("/")
      ? rawMetadata.slice(1)
      : rawMetadata;

    const brokenJson = `{${trimmed}`;
    parsedMetadata = JSON.parse(brokenJson);
    appVersion = parsedMetadata.AndroidAppVersion ?? null;
    webClientVersion = parsedMetadata.AndoroidWebCleintVersion?.trim() ?? null;
  }

  return (
    <div
      className="select-node-view"
      style={{
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div>
        <p>ID: {device?.subscribeData?.mobileId?.mobileId}</p>
        <p>App: v{appVersion}</p>
        <p>Web App: v{webClientVersion}</p>
      </div>
      <button
        className="btn secondary save-view"
        onClick={() => onClose()}
        style={{ marginTop: "20px" }}
      >
        {t("buttons.Close")}
      </button>
    </div>
  );
};

export default React.memo(DeviceInfo);
